"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const modul_svg_1 = __importDefault(require("@components/icons/modul.svg"));
const exercising_svg_1 = __importDefault(require("@components/icons/exercising.svg"));
const more_svg_1 = __importDefault(require("@components/icons/more.svg"));
const profile_svg_1 = __importDefault(require("@components/icons/profile.svg"));
const styled_components_1 = __importDefault(require("styled-components"));
const ControlPanel = styled_components_1.default.div `
    width: 100%;
    max-width: 720px;
    left: calc(50% - 360px);
    flex-direction: row;
    padding: 9px 24.5px 9px 23.5px;
    justify-content: space-evenly;
    align-items: center;
    flex-shrink: 0;
    border-radius: 50px;
    background: transparent;
    height: 40px;
    margin-top: 20px;
    
    @media (max-width:700px) {
        background: #7B4EF8;
        display: flex;

    }
    @media (max-height: 450px) {
        margin-top: 10px;
    }
`;
const Link = styled_components_1.default.a `
        color: #A5A6FE;
        text-align: center;
        font-family: Inter;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%; /* 10px */
        text-decoration: none!important;
        flex-direction: column;
        align-items: center;
        min-width: 50px;
    display: none;
    
@media (max-width:700px) {
    display: flex;
}
`;
const MenuBarExercise = ({ children }) => {
    return (react_1.default.createElement(ControlPanel, null,
        react_1.default.createElement(Link, { href: "/list_exercise" },
            react_1.default.createElement(exercising_svg_1.default, null),
            "\u0423\u043F\u0440\u0430\u0436\u043D\u0435\u043D\u0438\u044F"),
        react_1.default.createElement(Link, { href: "/module" },
            react_1.default.createElement(modul_svg_1.default, null),
            "\u041C\u043E\u0434\u0443\u043B\u0438"),
        react_1.default.createElement("div", { className: "button-group" }, children),
        react_1.default.createElement(Link, { href: "/profile" },
            react_1.default.createElement(profile_svg_1.default, null),
            "\u041F\u0440\u043E\u0444\u0438\u043B\u044C"),
        react_1.default.createElement(Link, { href: "/more" },
            react_1.default.createElement(more_svg_1.default, null),
            "\u0422\u0430\u0440\u0438\u0444\u044B")));
};
exports.default = MenuBarExercise;
